// extracted by mini-css-extract-plugin
module.exports = {"statistic":"statistic__Asyw2QMrGOAlq"};